import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

import { type CustomFormulaProps } from '../CustomFormula';

enum CustomFormulaTags {
  BREAKOUTS = 'Breakouts',
  CLOGGED_PORES = 'Clogged pores',
  WHITEHEADS = 'Whiteheads',
  REDNESS = 'Redness',
  BLACKHEADS = 'Blackheads',
  FINE_LINES = 'Fine lines',
  DARK_SPOTS = 'Dark spots',
  HAIR_THINNING = 'Hair thinning',
}

export const ACNE_CUSTOM_FORMULA_CONTENT: CustomFormulaProps = {
  mobileImage: (
    <StaticImage
      src="../images/mobileBg@3x.jpg"
      alt="Young brunette woman with curly hair, looking in the bathroom mirror while applying Curology Custom Formula, with the uncapped open bottle on a white shelf next to her."
      css={[mobileOnly('block', 'mdUp')]}
      loading="eager"
      objectFit="fill"
      objectPosition="center"
    />
  ),
  desktopImage: (
    <StaticImage
      src="../images/desktopBg@1x.jpg"
      alt="Young brunette woman with curly hair, looking in the bathroom mirror while applying Curology Custom Formula, with the uncapped open bottle on a white shelf next to her."
      css={[desktopOnly()]}
      loading="eager"
      objectFit="cover"
      objectPosition="center"
    />
  ),
  title: (
    <React.Fragment>
      Custom Formula<sup>Rx</sup> for acne
    </React.Fragment>
  ),
  subtitle:
    'Help clear your skin with a personalized, Rx acne cream—prescribed for you by a dermatology provider. Your Curology Custom Formula is made with acne-busting ingredients picked for you, which can include tretinoin, azelaic acid, clindamycin, and more.',
  tagHeadline: 'Ingredients proven to tackle',
  tags: [
    CustomFormulaTags.BREAKOUTS,
    CustomFormulaTags.CLOGGED_PORES,
    CustomFormulaTags.WHITEHEADS,
    CustomFormulaTags.REDNESS,
    CustomFormulaTags.BLACKHEADS,
  ],
  disclaimer: '*Subject to consultation. Cancel anytime.',
  price: (
    <React.Fragment>
      <strong>$29.95</strong>/month
    </React.Fragment>
  ),
  ctaButton: {
    buttonText: 'Get my formula',
  },
};

export const GENERAL_PURPOSE_FORMULA_CONTENT: CustomFormulaProps = {
  mobileImage: (
    <StaticImage
      src="../images/generalProducts@3x.jpg"
      alt="A display of Curology Custom Formula bottles on a white shelf."
      css={[mobileOnly('block', 'mdUp')]}
      loading="eager"
      objectFit="fill"
      objectPosition="center"
    />
  ),
  desktopImage: (
    <StaticImage
      src="../images/generalProducts.jpg"
      alt="A display of Curology Custom Formula bottles on a white shelf."
      css={[desktopOnly()]}
      loading="eager"
      objectFit="cover"
      objectPosition="center"
    />
  ),
  title: <React.Fragment>Good skin days ahead</React.Fragment>,
  subtitle: `Join the 1M+ patients who’ve tackled everything from acne, to fine lines, to hair thinning with prescription-powered treatments, personalized by a Licensed Dermatology Provider.`,
  tagHeadline: 'Ingredients proven to tackle',
  tags: [
    CustomFormulaTags.BREAKOUTS,
    CustomFormulaTags.REDNESS,
    CustomFormulaTags.FINE_LINES,
    CustomFormulaTags.DARK_SPOTS,
    CustomFormulaTags.HAIR_THINNING,
  ],
  disclaimer: '*Subject to consultation. Cancel anytime.',
  price: (
    <React.Fragment>
      <strong>$29.95</strong>/month
    </React.Fragment>
  ),
  ctaButton: {
    buttonText: 'Start my journey',
  },
};
